import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { VirtualClassPageRoutingModule } from './virtual-class-routing.module';

import { VirtualClassPage } from './virtual-class.page';
import { ComponentsAdminModule } from '../../componentsAdmin/components-admin.module';
import { TestComponentsModule } from './test-components/test-components.module';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    VirtualClassPageRoutingModule,
    ComponentsAdminModule,
    TestComponentsModule,
    GeneralesComponentsModule,
  ],
  declarations: [VirtualClassPage],
})
export class VirtualClassPageModule {}
